import React, { useState, useEffect, useCallback } from "react";
import debounce from "lodash.debounce";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as moment from "moment";
import { TableSection, SearchWrapper, SelectWrapper, } from "../../../private/Admin/DashBoard/dashBoardStyled";
import axioPath from "../../../../../api/axioPath";
import { Helmet } from "react-helmet";
import Layout from "web/components/Layout";
import Spinner from "../../../../../web/components/Spinner";
import { AiOutlineSearch } from "react-icons/ai";
import CsvDownloader from "react-csv-downloader";
import Pagination from "@material-ui/lab/Pagination";
import { PageWrapper, InnerHeader, TableWrapper } from './orderReportsStyled'
import { fetchLanguageContentNew } from "redux/actions/language";
import { orderReportsApi } from "redux/actions/myPickupOrders"
import MobileViewDelOrders from "./MobileViewDelOrders";
import MobileViewPickupOrders from "./MobileViewPickupOrders";
import MultiSelect from "web/components/MultiSelect";
import AlertModal from 'web/components/AlertModal';
import { setDelOrdersCsvFunction, setPickupOrdersCsvFunction } from './helper';
import { initialStateObject, selectStyle, requestTypeList, csvHeaderArray, pickupCsvHeaderArray, orderStatusList, pickupStatusList, greenButton } from './Constants'
import TableDataDelOrders from "./TableDataDelOrders";
import TableDataPickupOrders from "./TableDataPickupOrders";

import { getAllStatesOfCountry, getAllCitiesOfState } from "helpers";

function OrderReportsFront() {
  const token = localStorage.getItem("token");
  let history = useHistory();
  const dispatch = useDispatch();
  const storedData = useSelector((state) => state.storedData.payload);
  const [loaderVisible, setLoaderVisible] = useState(false);
  const [isExporting, setIsExporting] = useState(false)
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [finalData, setFinalData] = useState();
  const [csvData, setCsvData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [tableSearch, setTableSearch] = useState("");

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchMyApi()
  }, []);

  useEffect(() => {
    if (languageContentNew?.H8_Nav_Orders_Page) setPageLanguageContents(languageContentNew.H8_Nav_Orders_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  const [orderFilterState, setUserFilterState] = useState(initialStateObject);

  // const states = State.getStatesOfCountry("US").map((state) => ({
  //   value: state.name,
  //   label: `${state.isoCode}-${state.name}`,
  //   isoCode: state.isoCode,
  // }));
  const states = getAllStatesOfCountry('US').map((state) => ({
    value: state.name,
    label: `${state.isoCode}-${state.name}`,
    isoCode: state.isoCode,
  }));
  const currentState = states
        .find((state) => state.value === orderFilterState.state)?.isoCode || "";
  const filterCities = getAllCitiesOfState(currentState, 'US')
    ?.map((city) => ({ value: city, label: city })) ?? [];

  const handleFilterStateChange = (e) => {
    setPage(1);
    const { id, value } = e.target;
    setUserFilterState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    if (id === "state") {
      setUserFilterState((prevState) => ({
        ...prevState,
        city: "",
      }));
    }
  };

  const handleStatusChange = data => {
    const containsAll = Array.isArray(data) && data[data.length - 1].value === 'ALL'
    setUserFilterState(prevState => ({
      ...prevState,
      status: containsAll ? [{ value: 'ALL', label: 'ALL' }] : (data?.filter(data => data.value !== 'ALL') || [{ value: 'ALL', label: 'ALL' }])
    }));
  }

  // parameter of fetchMyApi should be in the following order, 1- orderFilterState, 2-recent state updated values (this is used in case of callig the function right after the state update)
  const fetchMyApi = async (latestOrderFilterState, recentStateUpdatedValues) => {
    let tempOrderFilter = latestOrderFilterState || orderFilterState
    let currentPageValue = recentStateUpdatedValues?.page ?? page

    let fromDateVal = moment(tempOrderFilter.fromDate);
    let toDateVal = moment(tempOrderFilter.toDate);

    if (!fromDateVal.isValid() || !toDateVal.isValid() || toDateVal.isBefore(fromDateVal)) {
      setModalContent('Please select a valid date.');
      setModal(!modal);
      return;
    }
    setLoaderVisible(true);

    let data = {
      locationId: localStorage.getItem("locationID"),
      size: 10,
      number: currentPageValue > 1 ? currentPageValue - 1 : 0,
      sort: "DESC",
      state: tempOrderFilter.state === 'ALL' ? '' : tempOrderFilter.state,
      city: tempOrderFilter.city === 'ALL' ? '' : tempOrderFilter.city,
      orderStatus: tempOrderFilter.status.map(data => data.value),
      searchBy: recentStateUpdatedValues?.searchText ?? tableSearch,
      fromDate: moment(tempOrderFilter.fromDate).format('YYYY/MM/DD'),
      toDate: moment(tempOrderFilter.toDate).format('YYYY/MM/DD')
    }
    let url = 'order/pickup/get_order_list'
    if (tempOrderFilter.requestType === 'Delivery') {
      url = "/order/v2/report/get_order_list"
      data.orderType = tempOrderFilter.orderType
    }
    let response
    response = await dispatch(orderReportsApi(url, data, token));
    if (response?.success) {
      setLoaderVisible(false);
      if (response.data?.orderList || response.data?.pickupOrderList) {
        let userSubList = response.data?.orderList || response.data?.pickupOrderList;
        setFinalData(userSubList);
        setPageCount(response.data?.totalPages ?? 1);
      }
    } else {
      setLoaderVisible(false);
      if (response?.statusCode === 401) {
        history.push('./sign-in');
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.message || response?.message || 'Something went wrong, please try again in sometime.');
        setModal(!modal);
      }
    }
  };

  const requestTypeChangeFunction = (e) => {
    setFinalData()
    setPageCount(0)
    setTableSearch('')
    setPage(1)
    let updatedState = { ...initialStateObject, requestType: e.target.value }
    setUserFilterState(updatedState)
    fetchMyApi(updatedState, { page: 1, searchText: '' })
  }

  const handleChange = (event, value) => {
    setPage(value);
    fetchMyApi(undefined, { page: value })
  };

  const handleSearchChange = (event) => {
    setPage(1)
    let searchValue = event.target.value
    setTableSearch(searchValue)
    debouncedSearch(orderFilterState, searchValue);
  }

  const debouncedSearch = useCallback(debounce((orderFilterState, searchValue) => fetchMyApi(orderFilterState, { searchText: searchValue }), 500), []);

  const csvExportFunction = async () => {
    setIsExporting(true)
    let data = {
      locationId: localStorage.getItem("locationID"),
      size: 100,
      number: 0,
      sort: "ASC",
      state: orderFilterState.state === 'ALL' ? '' : orderFilterState.state,
      city: orderFilterState.city === 'ALL' ? '' : orderFilterState.city,
      orderStatus: orderFilterState.status.map(data => data.value),
      searchBy: tableSearch,
      fromDate: moment(orderFilterState.fromDate).format('YYYY/MM/DD'),
      toDate: moment(orderFilterState.toDate).format('YYYY/MM/DD')
    };
    let url = 'order/pickup/get_order_list'
    if (orderFilterState.requestType === 'Delivery') {
      url = "/order/v2/report/get_order_list/export"
      data.orderType = orderFilterState.orderType
    }

    let allData = [];
    let totalPages = 1;
    let currentPage = 0;

    while (currentPage < totalPages) {
      data.number = currentPage;
      const response = await dispatch(orderReportsApi(url, data, token));

      if (response?.success) {
        if (response.data?.orderList || response.data?.pickupOrderList) {
          allData = allData.concat(response.data.orderList || response.data?.pickupOrderList);
        }
        totalPages = response.data?.totalPages ?? 1;
        currentPage += 1;
      } else {
        if (response?.statusCode === 401) {
          history.push('./sign-in');
          window.location.reload(false);
        }
        break;
      }
    }
    setIsExporting(false);
    let tempCsvData = []
    if (orderFilterState.requestType === 'Delivery') tempCsvData = setDelOrdersCsvFunction(allData);
    else tempCsvData = setPickupOrdersCsvFunction(allData);
    setCsvData(tempCsvData);
    document.getElementById('userPickupOrderReportcsvExportRef').click();
  }

  return (
    <>
      <Helmet title="Manage All of Your End of the Month Accounting | PalletTrader" >
        <meta name="description"
          content="Pallet buyers and sellers can export any transaction at the order report center. Filter your reports by time period, location name, order status, and city or state. " />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/order-reports" />
      </Helmet>
      <Layout transparentHeader={false} topBarViewMobile={"hide"} pageType="reports">
        <PageWrapper>
          <div className="web-view">
            <TableWrapper>
              <div>
                <div class="community-details-header seller">
                  <div class="community-name">
                    <h4>{orderFilterState.requestType === 'Delivery' ? 'My Order Report' : 'My Pickup Order Report'}</h4>
                  </div>
                  <div className="col-md-6 col-12 d-flex justify-content-end px-0">
                    {(storedData?.data?.isEnablePickupFeature || storedData?.data?.isEnablePtPlusFeature) &&
                      <div className="request-type-class">
                        <p>Request Type : </p>
                        <SelectWrapper>
                          <select
                            style={selectStyle}
                            id="requestType"
                            value={orderFilterState.requestType}
                            onChange={(e) => requestTypeChangeFunction(e)}
                          >
                            {requestTypeList.map((data, index) => {
                              return <option value={data.value}>{data.label}</option>;
                            })}
                          </select>
                        </SelectWrapper>
                      </div>
                    }
                    <SearchWrapper>
                      <input
                        style={{ border: "1px solid #69BBE0", borderRadius: "5px" }}
                        type="text"
                        placeholder={pageLanguageContents?.Order_Report[16]?.Search}
                        value={tableSearch}
                        onChange={handleSearchChange}
                      />
                      <AiOutlineSearch />
                    </SearchWrapper>
                    <div>
                      <button
                        // disabled={finalData && finalData?.length === 0}
                        style={greenButton}
                        onClick={csvExportFunction}
                      >{isExporting ? 'Exporting...' : 'Export'}
                      </button>
                    </div>
                    <CsvDownloader
                      filename="User Activity Report"
                      columns={orderFilterState.requestType === 'Delivery' ? csvHeaderArray : pickupCsvHeaderArray}
                      datas={csvData}
                    >
                      <button
                        id='userPickupOrderReportcsvExportRef'
                        style={{ display: 'none' }}
                      >
                        {pageLanguageContents?.Order_Report[17]?.Export}
                      </button>
                    </CsvDownloader>
                  </div>
                </div>
                {loaderVisible && <Spinner />}
                <div class="column">
                  <InnerHeader>
                    {orderFilterState.requestType === 'Delivery' &&
                      <div>
                        <p>
                          {pageLanguageContents?.Order_Report[1]?.Type}
                        </p>
                        <SelectWrapper>
                          <select
                            style={selectStyle}
                            id="orderType"
                            value={orderFilterState.orderType}
                            onChange={handleFilterStateChange}
                          >
                            <option value="BOTH">
                              {pageLanguageContents?.Order_Report[2]?.Type_1}
                            </option>
                            <option value="BUYER">
                              {pageLanguageContents?.Order_Report[3]?.Type_2}
                            </option>
                            <option value="SELLER">
                              {pageLanguageContents?.Order_Report[4]?.Type_3}
                            </option>
                          </select>
                        </SelectWrapper>
                      </div>
                    }
                    <div>
                      <p>
                        {pageLanguageContents?.Order_Report[5]?.State}
                      </p>
                      <SelectWrapper>
                        <select
                          style={selectStyle}
                          id="state"
                          value={orderFilterState.state}
                          onChange={handleFilterStateChange}
                        >
                          <option value="">All</option>
                          {states.map((data, index) => {
                            return <option value={data.value}>{data.label}</option>;
                          })}
                        </select>
                      </SelectWrapper>
                    </div>
                    <div>
                      <p>
                        {pageLanguageContents?.Order_Report[6]?.City}
                      </p>
                      <SelectWrapper>
                        <select
                          style={selectStyle}
                          id="city"
                          value={orderFilterState.city}
                          onChange={handleFilterStateChange}
                        >
                          <option value="">All</option>
                          {filterCities.map((data, index) => {
                            return <option value={data.label}>{data.label}</option>;
                          })}
                        </select>
                      </SelectWrapper>
                    </div>
                    <div style={{ maxWidth: '250px' }}>
                      <p>
                        {pageLanguageContents?.Order_Report[8]?.Status}
                      </p>
                      <SelectWrapper>
                        <MultiSelect
                          name="pickupOrderStatus"
                          returnValue='true'
                          data={orderFilterState.requestType === 'Delivery' ? orderStatusList : pickupStatusList}
                          multiSelectVal={orderFilterState.status}
                          defaultValueArr={orderFilterState.status}
                          isSearchable={false}
                          onChangeHandler={(data) => handleStatusChange(data)}
                        />
                      </SelectWrapper>
                    </div>
                    <div>
                      <p>
                        {pageLanguageContents?.Order_Report[7]?.Date}
                      </p>
                      <div className="date">
                        <SelectWrapper>
                          <input
                            type="date"
                            max={orderFilterState.toDate}
                            id="fromDate"
                            value={orderFilterState.fromDate}
                            onChange={handleFilterStateChange}
                          />
                        </SelectWrapper>
                        <p>
                          {pageLanguageContents?.Order_Report[18]?.To}
                        </p>
                        <SelectWrapper>
                          <input
                            type="date"
                            min={orderFilterState.fromDate}
                            id="toDate"
                            value={orderFilterState.toDate}
                            onChange={handleFilterStateChange}
                          />
                        </SelectWrapper>
                        <button style={greenButton} onClick={() => {
                          setPage(1)
                          fetchMyApi(undefined, { page: 1 })
                        }}>Submit</button>
                      </div>
                    </div>
                  </InnerHeader>
                </div>
                <TableSection>
                  {orderFilterState.requestType === 'Delivery' ?
                    <TableDataDelOrders finalData={finalData} />
                    :
                    <TableDataPickupOrders finalData={finalData} />
                  }
                </TableSection>
                {finalData?.length !== 0 && (<Pagination count={pageCount} page={page} onChange={handleChange} />)}
              </div>
            </TableWrapper>
          </div>
          <div className="mobile-view">
            {orderFilterState.requestType === 'Delivery' ?
              <MobileViewDelOrders
                loaderVisible={loaderVisible}
                tableSearch={tableSearch}
                requestTypeChangeFunction={requestTypeChangeFunction}
                handleSearchChange={handleSearchChange}
                csvExportFunction={csvExportFunction}
                isExporting={isExporting}
                finalData={finalData}
                orderFilterState={orderFilterState}
                handleFilterStateChange={handleFilterStateChange}
                handleStatusChange={handleStatusChange}
                filterCities={filterCities}
                states={states}
                statusList={orderStatusList}
                pageCount={pageCount}
                page={page}
                handleChange={handleChange}
                callFetchApi={() => {
                  setPage(1)
                  fetchMyApi(undefined, { page: 1 })
                }}
                callBack={(values) => {
                  setUserFilterState(values)
                }}
              />
              :
              <MobileViewPickupOrders
                loaderVisible={loaderVisible}
                tableSearch={tableSearch}
                requestTypeChangeFunction={requestTypeChangeFunction}
                handleSearchChange={handleSearchChange}
                csvExportFunction={csvExportFunction}
                isExporting={isExporting}
                finalData={finalData}
                orderFilterState={orderFilterState}
                handleFilterStateChange={handleFilterStateChange}
                handleStatusChange={handleStatusChange}
                filterCities={filterCities}
                states={states}
                statusList={orderStatusList}
                pageCount={pageCount}
                page={page}
                handleChange={handleChange}
                callFetchApi={() => {
                  setPage(1)
                  fetchMyApi(undefined, { page: 1 })
                }}
                callBack={(values) => {
                  setUserFilterState(values)
                }}
              />
            }
          </div>
        </PageWrapper >
        <AlertModal
          isOpen={modal}
          toggle={() => setModal(!modal)}
          title=''
          content={modalContent}
        />
      </Layout >
    </>
  );
}

export default OrderReportsFront;
